import { CoreIcon } from 'src/components/Icons';
import { AppPresets } from 'src/constants/moduleManagementConsts';

export const GENERAL_SETUP_APPS = [
  {
    name: 'Embeds and Links',
    description:
      'Connect products you already use as an embed or link. Select this option if you don’t see your app below.',
    Icon: CoreIcon,
    preset: AppPresets.PartnerApp,
  },
  {
    name: 'Create a Custom App',
    description:
      'Achieve any desired functionality by building your own custom web app and embedding it in the portal.',
    Icon: CoreIcon,
    preset: AppPresets.CustomApp,
  },
];
